module.exports = __webpack_public_path__ + "img/AR727.9117951b.png";